import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import { FC, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import crm2 from 'src/assets/images/crm-preview/integrated-platforms.png'
import crm1 from 'src/assets/images/crm-preview/people-list.png'
import slide1 from 'src/assets/images/crm-preview/subscriptions.png'
import slide2 from 'src/assets/images/people/persons (6).png'
import Hero from 'src/sections/capterra/Hero'
import Resources from 'src/sections/capterra/Resources'
import { Touchpoints } from 'src/sections/capterra/Touchpoints'
import { TwoSidesPlatformSection } from 'src/sections/capterra/TwoSidesPlatformSection'
import { ClientsSection } from 'src/sections/commonSections/ClientsSection/ClientsSection'
import { FeedbackSection } from 'src/sections/homePageSections/FeedbackSection/FeedbackSection'
import { PlatformsSection } from 'src/sections/homePageSections/PlatformsSection/PlatformsSection'
import { ServicesSection } from 'src/sections/homePageSections/ServicesSection/ServicesSection'
import membersPattern1 from 'src/sections/productPageSections/ProductItemSection/images/patterns/members-pattern-1.png'
import membersPattern2 from 'src/sections/productPageSections/ProductItemSection/images/patterns/members-pattern-2.png'
import membersPattern3 from 'src/sections/productPageSections/ProductItemSection/images/patterns/members-pattern-3.png'

import { useMetaQuery } from '../../../graphql'
import { ContactForm } from '../../../sections/capterra/ContactForm'
import { Pricing } from '../../../sections/capterra/Pricing'
import { clientsTypes } from '../../ClientsPage/ClientsPage'
import { clients } from '../crm/Capterra'
import { benefits, resourcesData } from '../hospitalityProperty/Capterra'

export const product = {
  title: 'end-to-End Membership Management',
  about: 'PeopleVine allows you to manage and engage with your member base while creating a self-service experience, so your staff can focus on growth.',
  list: [
    {
      image: crm1,
      list: [
        {
          title: 'A Single Dashboard',
          items: ['Application processing and onboarding', 'Member self-service tools', 'Branded member portal', 'Searchable member directory'],
        },
        {
          title: 'Member Interaction Tracking',
          items: ['Triggered, automated outreach', 'Email and SMS newsletters', 'Affiliate program tracking', 'Multi-location support'],
        },
      ],
    },
    {
      image: crm2,
      list: [
        {
          title: 'Integrated Payment and Accounting',
          items: ['Automated subscription payments', 'Billing and receipt management', 'Cardless payments', 'Membership dues processing'],
        },
        {
          title: 'Automated Marketing',
          items: ['Drip and date-based campaigns', 'Automatic triggers', 'Chatbots on Twitter and SMS', 'Third-party integrations and APIs'],
        },
      ],
    },
  ],
  themeColor: 'black',
  additionalClass: 'members',
  key: 'management',
  patterns: [
    {
      image: membersPattern1,
      styles: {
        top: '10%',
        right: '0',
      },
    },
    {
      image: membersPattern2,
      styles: {
        top: '15%',
        left: '5%',
      },
    },
    {
      image: membersPattern3,
      styles: {
        top: '35%',
        left: '0',
      },
    },
  ],
  index: 1,
}

const heroSlides = [
  {
    title: 'The premier membership platform',
    subtitle: 'Designed from the ground up to create premier member experiences, empower ops teams to excel at scale and build forever transactions.',
    img: slide1,
  },
  {
    title: 'Elevate your member experience',
    subtitle: 'Build your member community, drive engagement, and connect the dots that elevate experiences and revenues.',
    img: slide2,
  },
]

export const client = clientsTypes.find(item => item.clientName.includes('zero'))

const Capterra: FC = () => {
  const { data } = useMetaQuery({ variables: { where: { slug: 'capterra-membership' } } })
  const meta = data?.metas?.[0]

  useEffect(() => {
    const twoSidesAnimation = () => {
      ScrollTrigger.matchMedia({
        '(min-width: 1200px)': () => {
          gsap.to('.two-sides-platform-part--dark', {
            scrollTrigger: {
              trigger: '.two-sides-platform-part--dark',
              start: '15% 90%',
              end: '70% 30%',
              scrub: 1,
            },
            ease: 'none',
            clipPath: 'polygon(0% 0%, 0% 0%, 100% 100%, 0% 100%)',
          })
        },
      })
    }

    window.addEventListener('load', () => twoSidesAnimation())
    return () => {
      window.removeEventListener('load', () => twoSidesAnimation())
    }
  })

  return (
    <section className='capterra'>
      <Helmet title={meta?.title as string} />
      <Hero slides={heroSlides} />
      <Resources theme={'light'} title={'key ops team benefits'} data={resourcesData} />
      <Resources theme={'light'} title={'key member\nbenefits'} data={benefits} />
      <ClientsSection theme={'light'} isHomePage={true} hasSeeMore={false} hasReadMore={false} clients={clients} />
      <ServicesSection titleMaxWidth={950} title={'Member Experience Platform Subscription Management, & CRM'} />
      <Touchpoints />
      <TwoSidesPlatformSection />
      <PlatformsSection title={'Integrations'} readMore={false} />
      <Pricing />
      <FeedbackSection hasTitle={true} theme={'grey'} />
      <ContactForm />
    </section>
  )
}

export default Capterra
